import { Form, transMoney, useCoordSetAndLook, useI18n } from "@jog/react-components";
import { CoordSetAndLookProduct } from "./Product";
export const Cart = () => {
    const { form, productData, onSubmit } = useCoordSetAndLook();
    return (<Form {...form}>
            <form id="coord-set-and-look-form" onSubmit={form.handleSubmit(onSubmit)}>
                {Object.values(productData).map((product) => (<CoordSetAndLookProduct key={product.prismic.id} {...product}/>))}
                <AddToCart />
            </form>
        </Form>);
};
export const AddToCart = () => {
    const { selectedProducts, total } = useCoordSetAndLook();
    const { $t } = useI18n();
    return (<div className="mt-5 lg:mt-10">
            <div className="flex items-center justify-between">
                <div className="text-black">
                    {$t("Total number of articles: {count}", { count: `${selectedProducts.length}` })}
                </div>
                <div>{transMoney(total)}</div>
            </div>
            <button className="mt-4 h-12 w-full bg-black text-center text-sm uppercase text-gray-cream focus:outline-none">
                {$t("Add To Cart")}
            </button>
        </div>);
};
